import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './download.css';
import emailjs from 'emailjs-com';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../OurCourses/firebase';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useEffect } from "react";
import { motion, AnimatePresence } from 'framer-motion';

function Download() {
  const [user, setUser] = useState(null);
  const [activeForm, setActiveForm] = useState('admission'); 
  const [formData, setFormData] = useState({ 
    email: '',
    name: '',
    course: '',
    moduleName: '',
    contactNo: '',
    nicPassportNo: '',
    additional: '',
    applicationFile: null,
    paymentSlipFile: null,
  });

// Course-wise module list
  const courseModules = {
    "Certificate in Optician": [
      "CO101 - General Science",
      "CO102 - Optics",
      "CO103 - Anatomy & Physiology of Eye",
      "CO104 - Comman Eye Diseases",
      "CO105 - Clincal Optics & Refraction",
      "CO201 - Understanding Ophthalmic equipments",
      "CO201 - Ophthalmic Lenses & Frames",
      "CO204 - Prescription & Ocular Measurements",
      "CO204 - Sales & Marketing",
    ],
    "Diploma in Optometry": [
      "English",
      "Information Technology",
      "General Anatomy & Physiology",
      "General & Ocular Microbiology",
      "Biochemistry",
      "Optics-Geometrical & Physical",
      "Ocular Anatomy & Physiology",
      "Pharmacology",
      "Ocular Pathology I",
      "Clinical Procedure I",
      "Visual Optics",
      "Dispensing Optics",
      "Physiology Of Vision",
      "General Medicine",
      "Clinical Procedure II",
      "Ocular Pathology II",
      "Binocular Vision",
      "Contact Lens",
      "Geriatric & Pediatric Optometry",
      "Low Vision",
      "Public Health & Community Optometry",
      "Occupational Optometry",
      "Practice management",
      "Research Methodology & Professional Ethics",
      "Project Work",
      "Clinical Internship (OJT)",
    ],

     "Higher Diploma in Optometry": [
      "English",
      "Information Technology",
      "General Anatomy & Physiology",
      "General & Ocular Microbiology",
      "Biochemistry",
      "Optics-Geometrical & Physical",
      "Ocular Anatomy & Physiology",
      "Pharmacology",
      "Ocular Pathology I",
      "Clinical Procedure I",
      "Visual Optics",
      "Dispensing Optics",
      "Physiology Of Vision",
      "General Medicine",
      "Clinical Procedure II",
      "Ocular Pathology II",
      "Binocular Vision",
      "Contact Lens",
      "Geriatric & Pediatric Optometry",
      "Low Vision",
      "Public Health & Community Optometry",
      "Occupational Optometry",
      "Practice management",
      "Research Methodology & Professional Ethics",
      "Project Work",
      "Clinical Internship (OJT)",
    ],

      "NVQ Level 3": [
      "NVQ Assesment",
    ]
  };












  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: value,
  //   }));
  // };


    
  // Handle change for course and module
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Reset module if course is changed
    if (name === "course") {
      setFormData((prev) => ({
        ...prev,
        course: value,
        moduleName: "", // reset module
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };


  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const stateName = name === 'application' ? 'applicationFile' : 'paymentSlipFile';
    
    setFormData((prevData) => ({
      ...prevData,
      [stateName]: files[0],
    }));
  };

  const validateFiles = () => {
    const MAX_SIZE = 5 * 1024 * 1024; // 5MB
    
    // Only validate application file for exam fee
    // if (activeForm === 'exam' && !formData.applicationFile) {
    //   return 'Please fill the exam application ';
    // }
    
    if (!formData.paymentSlipFile) {
      return 'Please upload the payment slip';
    }
    
    if (activeForm === 'exam' && formData.applicationFile && formData.applicationFile.size > MAX_SIZE) {
      return 'Application file is too large (max 5MB)';
    }
    
    if (formData.paymentSlipFile.size > MAX_SIZE) {
      return 'Payment slip is too large (max 5MB)';
    }
    
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError(null);
    setSubmitSuccess(false);

    const validationError = validateFiles();
    if (validationError) {
      setSubmitError(validationError);
      setIsSubmitting(false);
      return;
    }

    try {
      const storage = getStorage();
      
      // Upload payment slip
      const paymentFileName = `payment_${Date.now()}_${formData.paymentSlipFile.name}`;
      const paymentRef = ref(storage, `formSubmissions/${paymentFileName}`);
      await uploadBytes(paymentRef, formData.paymentSlipFile);
      const paymentSlipUrl = await getDownloadURL(paymentRef);

      // Only upload application file if it exists (mainly for exam fee)
      let applicationFileUrl = '';
      let appFileName = '';
      if (formData.applicationFile) {
        appFileName = `application_${Date.now()}_${formData.applicationFile.name}`;
        const applicationRef = ref(storage, `formSubmissions/${appFileName}`);
        await uploadBytes(applicationRef, formData.applicationFile);
        applicationFileUrl = await getDownloadURL(applicationRef);
      }

      // Save text data to Firestore
      const submissionData = {
        name: formData.name,
        email: formData.email,
        course: formData.course,
        moduleName:formData.moduleName,
        contactNo: formData.contactNo,
        nicPassportNo: formData.nicPassportNo,
        additional: formData.additional,
        paymentFileName: paymentFileName,
        paymentSlipUrl,
        submittedAt: serverTimestamp(),
        status: 'pending',
        feeType: activeForm
      };

      // Only include application file data if it exists
      if (formData.applicationFile) {
        submissionData.applicationFileName = appFileName;
        submissionData.applicationFileUrl = applicationFileUrl;
      }

      await addDoc(collection(db, 'formSubmissions'), submissionData);

      // Prepare email data
      const emailData = {
        name: formData.name,
        email: formData.email,
        course: formData.course,
        moduleName:formData.moduleName,
        contactNo: formData.contactNo,
        nicPassportNo: formData.nicPassportNo,
        additional: formData.additional,
        paymentSlipUrl,
        feeType: activeForm
      };

      // Include application file in email if it exists
      if (formData.applicationFile) {
        emailData.applicationFileUrl = applicationFileUrl;
        emailData.applicationFileName = appFileName;
      }

      await emailjs.send(
        'service_gahawkc',
        'template_d5z5is8',
        emailData,
        'SmoVT3u-6A8Q9aI9_'
      );
  
      setSubmitSuccess(true);
      setFormData({
        email: '',
        name: '',
        course: '',
        moduleName: '',
        contactNo: '',
        nicPassportNo: '',
        additional: '',
        applicationFile: null,
        paymentSlipFile: null,
      });
      
    } catch (err) {
      console.error('Failed to submit registration:', err);
      setSubmitError(`Failed to submit registration: ${err.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  // Form variants for animation
  const formVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -50 }
  };

  // Button variants for animation
  const buttonVariants = {
    active: { backgroundColor: "#4CAF50", color: "white" },
    inactive: { backgroundColor: "#f5f5f5", color: "#333" }
  };







 











  return (
    <div className='application-download'>
      <h1 className="student-panel-title">Payment Portal</h1>
      <p className="student-guidlines-description">
      Welcome to the Payment Portal. Here you can pay your admission fee, exam fees, Course fee, other fee and view your past payments, 
  and download payment related documents. Please make sure to complete your payments before the due date.
      </p>
      
      {/* <div className="guidelines-downloads">
        <ul>
          <li>
            <a href="/applications/enroll_application.pdf" download>
              Course Enrollment Application 
              <span className="download-icon">⬇️</span>
            </a>
          </li>
          <li>
            <a href="/applications/Exam Application.pdf" download>
              Exam Application 
              <span className="download-icon">⬇️</span>
            </a>
          </li>
          <li>
            <a href="/applications/eyecareinstitutecoursedetails.pdf" download>
              Eye Care Institute Course Details 
              <span className="download-icon">⬇️</span>
            </a>
          </li>
          <li>
            <a href="/applications/Guidelines.pdf" download>
              Course Guidelines 
              <span className="download-icon">⬇️</span>
            </a>
          </li>
          <li>
            <a href="/applications/studentfeedback.pdf" download>
              Lecturer Evaluation 
              <span className="download-icon">⬇️</span>
            </a>
          </li>
        </ul>
      </div> */}
{/* 
      <h1 className="student-panel-title">Payment Portal</h1> */}
      <p className="student-guidlines-description">
        Please select the type of payment you wish to submit. Choose between Admission Fee, 
        Exam Fee, or Class Fee and fill out the corresponding form with your details and payment slip.
      </p>
      
      {/* Fee Type Selection Buttons */}
      <div className="fee-type-buttons">
        <motion.button
          variants={buttonVariants}
          animate={activeForm === 'admission' ? "active" : "inactive"}
          onClick={() => setActiveForm('admission')}
          className="fee-button"
        >
          Admission Fee
        </motion.button>
        
        <motion.button
          variants={buttonVariants}
          animate={activeForm === 'exam' ? "active" : "inactive"}
          onClick={() => setActiveForm('exam')}
          className="fee-button"
        >
          Exam Fee
        </motion.button>
        
        <motion.button
          variants={buttonVariants}
          animate={activeForm === 'course' ? "active" : "inactive"}
          onClick={() => setActiveForm('course')}
          className="fee-button"
        >
          Course Fee
        </motion.button>

          <motion.button
          variants={buttonVariants}
          animate={activeForm === 'other' ? "active" : "inactive"}
          onClick={() => setActiveForm('other')}
          className="fee-button"
        >
          Other
        </motion.button>
      </div>

      {user ? (
        submitSuccess ? (
          <div className="success-message">
            <h3 className='download-heading-form'>Thank you for your submission!</h3>
            <p>Your {activeForm} payment has been received successfully. We will review it and get back to you soon.</p>
            {/* <button 
              className="submit-button"
              onClick={() => setSubmitSuccess(false)}
            >
              Submit Another Payment
            </button> */}
          </div>

        ) : (

          <AnimatePresence mode="wait">
            <motion.div
              key={activeForm}
              variants={formVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              transition={{ duration: 0.3 }}
              className="form-container"
            >
              <form className="submission-form" onSubmit={handleSubmit}>
                <h2 className="form-title">
                  {activeForm === 'admission' && 'Admission Fee Payment'}
                  {activeForm === 'exam' && 'Exam Fee Payment'}
                  {activeForm === 'course' && 'Course Fee Payment'}
                  {activeForm === 'other' && 'Other Payment'}
                </h2>
                
                <div className="form-group">
                  <label htmlFor="fullName">Full Name *</label>
                  <input 
                    type="text" 
                    id="name" 
                    name="name" 
                    placeholder="Enter your full name" 
                    value={formData.name}
                    onChange={handleChange}
                    required 
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email" 
                    placeholder="example@email.com" 
                    value={formData.email}
                    onChange={handleChange}
                    required 
                  />
                </div>


                

 {activeForm === 'exam' && (
    <div className="form-group file-upload">
 {/* Course Selection */}
      <div className="form-group">
        <label htmlFor="course">Course</label>
        <select
          id="course"
          name="course"
          value={formData.course}
          onChange={handleChange}
          required
        >
          <option value="">-- Select Course --</option>
          {Object.keys(courseModules).map((course) => (
            <option key={course} value={course}>
              {course}
            </option>
          ))}
        </select>
      </div>

      {/* Module Selection */}
      <div className="form-group">
        <label htmlFor="module">Module</label>
        <select
          id="module"
          name="moduleName"
          value={formData.moduleName}
          onChange={handleChange}
          required
          disabled={!formData.course} // disable until course selected
        >
          <option value="">-- Select Module --</option>
          {formData.course &&
            courseModules[formData.course].map((module, index) => (
              <option key={index} value={module}>
                {module}
              </option>
            ))}
        </select>
      </div>

      </div>
 )}


                <div className="form-group">
                  <label htmlFor="contactNo">Contact Number *</label>
                  <input 
                    type="tel" 
                    id="contactNo" 
                    name="contactNo" 
                    placeholder="+94 77 123 4567" 
                    value={formData.contactNo}
                    onChange={handleChange}
                    required 
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="nicPassportNo">NIC Number *</label>
                  <input 
                    type="text" 
                    id="nicPassportNo" 
                    name="nicPassportNo" 
                    placeholder="199012345678 or 901234567V" 
                    value={formData.nicPassportNo}
                    onChange={handleChange}
                    required 
                  />
                </div>

                {/* Application file upload - only required for exam fee */}

                {/* {activeForm === 'exam' && (
                  <div className="form-group file-upload">
                    <label htmlFor="application">Upload Exam Application Form (PDF) *</label>



                      <div style={{ position: 'relative', margin: '20px 0' }}>
                        <input 
                          type="file" 
                          id="application" 
                          name="application"
                          style={{
                            position: 'relative',
                            display: 'block',
                            width: '100%',
                            padding: '15px',
                            border: '2px solid blue',
                            borderRadius: '4px',
                            backgroundColor: 'white',
                            zIndex: 1000,
                            opacity: 1,
                            visibility: 'visible'
                          }}
                          accept=".pdf,.doc,.docx" 
                          onChange={handleFileChange}
                          required 
                        />
                      </div>


                    {formData.applicationFile && (
                      <div className="file-info">
                        Selected: {formData.applicationFile.name} ({Math.round(formData.applicationFile.size / 1024)} KB)
                      </div>
                    )}
                    <small>Max file size: 5MB</small>
                  </div>
                )} */}

                {/* Payment slip upload - always required */}
                <div className="form-group file-upload">
                  <label htmlFor="paymentSlip">
                    {activeForm === 'admission' && 'Upload Admission Fee Payment Slip *'}
                    {activeForm === 'exam' && 'Upload Exam Fee Payment Slip *'}
                    {activeForm === 'course' && 'Upload Course Fee Payment Slip *'}
                  </label>

<div style={{ position: 'relative', margin: '20px 0' }}>
  <input 
    type="file" 
    id="paymentSlip" 
    name="paymentSlip"
    style={{
      position: 'relative',
      display: 'block',
      width: '100%',
      padding: '15px',
      border: '2px solid blue',
      borderRadius: '4px',
      backgroundColor: 'white',
      zIndex: 1000,
      opacity: 1,
      visibility: 'visible'
    }}
    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
    onChange={handleFileChange}
    required 
  />
</div>


                  {formData.paymentSlipFile && (
                    <div className="file-info">
                      Selected: {formData.paymentSlipFile.name} ({Math.round(formData.paymentSlipFile.size / 1024)} KB)
                    </div>
                  )}
                  <small>Max file size: 5MB</small>
                </div>

                <div className="form-group">
                  <label htmlFor="additional">Additional Comments</label>
                  <textarea 
                    id="additional" 
                    name="additional" 
                    placeholder="Any special instructions or notes..." 
                    value={formData.additional}
                    onChange={handleChange}
                    rows="4"
                  ></textarea>
                </div>

                {submitError && <div className="error-message">{submitError}</div>}

                <button 
                  type="submit" 
                  className="submit-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Submitting...' : `Submit ${activeForm.charAt(0).toUpperCase() + activeForm.slice(1)} Payment`}
                </button>
              </form>
            </motion.div>
          </AnimatePresence>
        )
      ) : (
        <div className="login-required-message">
          <h3>Please log in to submit your payment</h3>
          <p>
            You need to <Link to="/signin">sign in</Link> before submitting your payment. 
            If you don't have an account, please <Link to="/signup">sign up</Link>.
          </p>
        </div>
      )}
    </div>
  );
}

export default Download;
